import type React from 'react';
import type { ErrorType } from '../../model/types';
import usePropState from '../../utils/usePropState';
import FormGroup from './FormGroup';

export interface Props extends Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'id' | 'className'> {
    className?: string;
    name: string;
    label?: string;
    description?: string;
    error?: ErrorType;
}

export default function InputGroup({ className, label, error: initialError, type, description, ...inputProps }: Props) {
    const [error, setError] = usePropState(initialError);

    if (type === 'password') {
        throw new Error('InputGroup does not support type password, use PasswordGroup instead');
    }

    return (
        <FormGroup className={className} error={error} id={inputProps.name} label={label}>
            {description && <small>{description}</small>}
            <input
                aria-describedby={`error_feedback_${inputProps.name}`}
                aria-invalid={!!error}
                className="form-control"
                id={inputProps.name}
                {...inputProps}
                onChange={(e) => {
                    setError(undefined);
                    inputProps.onChange?.(e);
                }}
                type={type}
            />
        </FormGroup>
    );
}
